const part = [
    // {
    //     path: 'blocked-user-list',
    //     name: 'blocked-user-list',
    //     meta: {
    //         icon: 'md-people',
    //         title: '黑名单列表',
    //         notCache: true,
    //         access: ['S'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/account-management/blocked-user-management/blocked-user-list')
    // }
];

export default part;
